export const logStyles = {
  container: {
    margin: '2.6vh',            
    padding: '1.3vh',           
    fontSize: '0.9vw',          
    display: 'flex',
    flexDirection: 'column',
    gap: '1.3vh',               
  },
  logBlock: {
    border: '0.13vh solid transparent', 
    padding: '1.3vh',
    backgroundColor: 'var(--surface-2)',
    borderRadius: '2.6vh',      
    boxShadow: 'var(--shadow-sm)',
  },
  logField: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    marginBottom: '0.8vh',      
    gap: '1.3vw',
  },
  label: {
    fontWeight: 'bold',
    width: '13vw',             
    flexShrink: 0,
  },
  data: {
    fontStyle: 'italic',
    color: 'green', // log syntax status
  },
  user: {
    textTransform: 'uppercase',
    color: 'red', // log syntax status
    wordBreak: 'break-word',
  },
};
